import { useCallback } from 'react';

import { useStarterDashboardV2PageData } from 'src/app/pages/starterDashboardV2/pageContext';

import { useShareVisualModal } from './useShareVisualModal';

type Context = 'starter_dashboard_grow_petition';

export function useTriggerShareVisualModal(context: Context): () => Promise<void> {
	const { data } = useStarterDashboardV2PageData();

	const openShareVisualModal = useShareVisualModal();

	const triggerShareVisualModal = useCallback(async () => {
		return openShareVisualModal({ petition: data.petition, context }).waitForResult();
	}, [context, data.petition, openShareVisualModal]);

	return triggerShareVisualModal;
}
